/**
 * PlayByPlayIncident represents the incident recieved from PlayByPlay handler
 *
 * @prop {teamStatusID} number defines the ID of the team which recieved the incident
 * @prop {eventStatusID} number defines the ID of the incident (goal, penalty, free kick, etc.)
 * @prop {masterEventID} string it's the ID of the master(main) event
 */
export class PlayByPlayIncident {
    teamStatusID: number;
    eventStatusID: number;
    masterEventID: string;
    constructor(source: PlayByPlayIncident) {
        this.teamStatusID = source.teamStatusID;
        this.eventStatusID = source.eventStatusID;
        this.masterEventID = source.masterEventID;
    }
}